import { createContext, useState } from "react";

export const OrderTypeContext = createContext("");
export const OrderTypeProvider = ({ children }) => {
  const [orderTypeContext, setOrderTypeContext] = useState("tableside");

  const value = { orderTypeContext, setOrderTypeContext };
  return (
    <OrderTypeContext.Provider value={value}>
      {children}
    </OrderTypeContext.Provider>
  );
};
